import React from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native';
import { pure } from '@dbk/ui-react-utils';

import AssetItem from '../../../../components/asset/asset-item';
import {
  AssetItemHeaderDescription,
} from '../../../../components/asset/asset-item/asset-item-header';
import NavigationArrow from '../../../../components/common/navigation-arrow';

import TableRow from '../../../../components/common/table-row';
import SimpleDate from '../../../../components/common/date';
import {
  AbbreviatedNumber,
  ChangeIndicatedAbbreviatedNumber,
} from '../../../../components/common/number';
import Text from '../../../../components/common/text';
import styles from '../../positions/asset-position/asset-position.styles';
import { HorizontalDashes } from '../../../../components/common/dashes';
import { SEPARATOR_STROKE } from '../../../../constants';

function Transaction(props) {
  const { columnWidths, row, assetCategory, options, screen, labels, transact, messages} = props;
  const {
    type,
    tradeNumber,
    valueDate,
    tradeDate,
    quantity,
    netAmount,
    purchasePrice,
    currency,
  } = row;


  function toggleModal(pageType) {
    const { changePage,tradeNumber,valueDate,tradeDate,row, transact, messages} = props;
    const adviceItem = {
      tradeNo: row.tradeNumber,
    };

     transact.getAdvices({
       adviceItem
    });
  }


  function showAdviseLink(){
    const {messages} = props;
    if(assetCategory === 'equities' ||  assetCategory == 'bonds' || assetCategory == 'various' ||  assetCategory == 'optionsDerivatives' || assetCategory == 'alternatives' || assetCategory == 'cash'){
      return (
        <View>
          <HorizontalDashes stroke={SEPARATOR_STROKE} />
          <TableRow style={styles.bottomRow}>
            <div id="txt_seeAdvice_transaction_test"
            style={{'cursor': 'pointer'}}
            onClick={() => toggleModal('pdf')}
            >
              <Text>
                {messages[labels.seeAdvice]}
              </Text>
              <span className="arrowClass"><NavigationArrow/></span>
            </div>
          </TableRow>
        </View>
      )
    } else {
      return null;
    }
  }

  function renderColumnValue(row, option) {
    const value = row[option.key];
    const {messages} = props;
    let align;

    if (option.type === 'date') {
      if(option.key === 'tradeDate'){
        align = 'left';
      } else {
        align = 'right';
      }
      return (
          <TableRow.Column
              align={align}
              width={option.width}
          >
              <SimpleDate value={value} />
          </TableRow.Column>
      );
    }

    if (option.type === 'currency') {
      return (
         <TableRow.Column width={option.width}>
            <ChangeIndicatedAbbreviatedNumber
              renderProps={{ size: 'large' }}
              value={value}
              maxDigits={8}
              renderExactAs="currency"
              onlyNegativeSign
            />
          </TableRow.Column>
      );
    }

    if (option.type === 'number') {
      return (
            <TableRow.Column width={option.width}>
                <AbbreviatedNumber
                  renderProps={{ size: 'large' }}
                  maxDigits={6}
                  maxDecimals={4}
                  maxDigitsIncludeDecimals={true}
                  value={value}
                />
              </TableRow.Column>
            );
    }

    return (<TableRow.Column width={option.width}>
              <Text>{ value }</Text>
            </TableRow.Column>
            )
  }

  if (transact.isEmpty) {
    transact.setIsEmpty(false);
    alert(messages['app.position.transDetails']);
  }

  if(!screen.isSmall) {
     return (
          <AssetItem>
            <TableRow style={styles.topRow}>
              <TableRow.Column
                align="left"
                testID="description"
              >
                <AssetItemHeaderDescription
                  row={{
                    description: type && (type.substr(0, 1).toUpperCase() + type.substr(1)),
                  }}
                />
              </TableRow.Column>
            </TableRow>
          <TableRow style={styles.bottomRow}>
            {options.map(opt => renderColumnValue(row, opt, screen))}
          </TableRow>
          {
             showAdviseLink()
          }
        </AssetItem>
      );
  } else {
  return(
       <AssetItem>
          <TableRow style={styles.topRow}>
            <TableRow.Column
              align="left"
              testID="description"
            >
              <AssetItemHeaderDescription
                row={{
                  description: type && (type.substr(0, 1).toUpperCase() + type.substr(1)),
                }}
              />
            </TableRow.Column>
          </TableRow>
          <TableRow style={styles.bottomRow}>
            {options.map(opt =>
              {
                if(opt.isPhone == true){
                  return (renderColumnValue(row, opt, screen))
                } else {
                  return null
                }
              })
            }
          </TableRow>
        </AssetItem>
    );
  }
}

Transaction.propTypes = {
  row: PropTypes.shape({
    type: PropTypes.string,
    quantity: PropTypes.number,
    netAmount: PropTypes.number,
    tradeDate: PropTypes.string,
  }),
  columnWidths: PropTypes.arrayOf(PropTypes.number),
  assetCategory:PropTypes.string,
  screen:PropTypes.shape({
    isSmall: PropTypes.bool
  }),
  labels: PropTypes.shape({
    seeAdvice: PropTypes.string,
  }),
  abbreviationRules: PropTypes.object,
};

export default pure(Transaction);
